import React, { useState, useEffect } from 'react';
import { useStore, useSettings } from '../context/store';

export default function Listings() {
    const { 
        state,
        dispatch 
    } = useStore();

    const settings = useSettings();

    const listings = state.listings;

    const getListingURL = listing => {
        let url = `${listing.id}-`;

        if ( listing.beds > 0 ) {
            url += `${Math.floor( listing.beds )}-bedroom-`;
        }

        if ( listing.city ) {
            url += `${listing.city}-`;
        }

        if ( listing.neighborhood ) {
            url += `${listing.neighborhood}-`;
        }

        url += 'apartment';

        // Lowercase, remove spaces, encode
        url = encodeURIComponent( url.toLowerCase().replace(/\s/g, '') );

        return '/rental/' + url;
    }
    
    const decimalToFraction = (float) => {
        const [
            integer,
            decimal
        ] = float.toString().split('.');
        
        let fraction = '';
        if ( decimal > 0 ) {
            switch ( decimal ) {
                case ".25":
                    fraction = integer + ' &#188;';
                case ".5":
                    fraction = integer + ' &#189;';
                case ".75":
                    fraction = integer + ' &#190;';
                default:
                    fraction = Math.round( float );
            }

            return fraction
        }

        return integer;
    }

    if ( listings.length ) {
        return (
            <div className="ygl-listings">
                {listings.map(( listing, index ) => {
                    const pre = 'ygl-listing';
                    const photo = listing.photos.length ? listing.photos[0] : null;
                    const cityNeighborhood = null !== listing.neighborhood ? `${listing.city}, ${listing.neighborhood}` : listing.city;
                    const listingURL = getListingURL( listing );

                    return (
                        <a className={pre} key={index} href={ listingURL }>
                            {null !== photo &&
                                <figure className={`${pre}__figure`}>
                                    <img src={photo} alt={`${listing.streetNumber} ${listing.streetName} photo`} />
                                </figure>
                            }
                            
                            <div className={`${pre}__text`}>
                                <div className={`${pre}__street`}>{listing.streetNumber} {listing.streetName}</div>
                                <div className={`${pre}__city`}>{cityNeighborhood}</div>

                                <div className={`${pre}__price`}>
                                    { `$${listing.price.toLocaleString()}` }
                                    <span>/mo</span>
                                </div>

                                <div className={`${pre}__meta`}>
                                    <div className={`${pre}__bed`} dangerouslySetInnerHTML={{ __html: decimalToFraction(listing.beds) + ' bed' }} />
                                    <div className={`${pre}__bath`} dangerouslySetInnerHTML={{ __html: decimalToFraction(listing.baths) + ' bath' }} />

                                    {null !== listing.squareFootage && 
                                        <div className={`${pre}__sqft`}>{listing.squareFootage.toLocaleString()} sqft</div>
                                    }
                                </div>

                                <div className={`${pre}__available`}>Available {listing.availableDate}</div>
                            </div>
                        </a>
                    )
                })}
            </div>
        )
    } else if ( ! state.loading ) {
        return (
            <div className="ygl-no-results">
                <div className="container">
                    <div className="ygl-no-results__inner">
                        <div className="lead">Sorry, there are no listings that match your filter selection.</div>
                        <p>
                            To get more results, try changing or removing your filters.<br />
                            Or, <a href={ settings.data.contactLink.url }>contact us</a> to get assistance with your apartment search.
                        </p>
                        <button className="c-btn c-btn-secondary ygl-no-results__reset-filters" onClick={ () => dispatch({ type: 'clearFilters' }) }>
                            Reset Filters
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return '';
}